module.exports = __webpack_public_path__ + "img/check-ok.1dcf1509.svg";